import { compare } from 'compare-versions';

import packageJson from '../../../../package.json';
import { RELEASE_STATE, RELEASE_TYPE } from '../constants';

const { version: CURRENT_VERSION } = packageJson;

export const filterDisplayableReleases = (releases) => releases
  .filter(release => release.state === RELEASE_STATE.PUBLISHED && release.type === RELEASE_TYPE.WEB && compare(release.releaseVersion, CURRENT_VERSION, '<='))
  .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));
